// extracted by mini-css-extract-plugin
module.exports = {"flat-selector":"flat-selector__2D92x","selector-option":"selector-option__2C20O","active":"active__3Ui_w"};